import { TextArea, TextAreaProps } from '@m/alchemy-ui/TextArea';
import { FieldDescription } from 'admin/company/components/ManageTeam/Styled/Styled';
import { Control, useController } from 'react-hook-form';
import { validationMessages } from './validationMessages';
import { StyledField } from '../styles';

type TextareaFieldProps = {
  name: string;
  label?: string;
  tip?: string;
  placeholder: string;
  isFullWidth: boolean;
  control: Control;
  required: boolean;
  maxLength?: number;
} & TextAreaProps;

export const TextareaField = ({
  name,
  label = '',
  tip = '',
  placeholder,
  isFullWidth,
  control,
  required = false,
  maxLength,
  ...restProps
}: TextareaFieldProps) => {
  const { field, fieldState } = useController({
    name,
    control,
    rules: {
      required: required && validationMessages.required,
      ...(maxLength ?
        { maxLength: { value: maxLength, message: `Maximum ${maxLength} characters` } }
      : {}),
    },
  });
  const { invalid, error } = fieldState;

  return (
    <StyledField
      labelVariant="emphasized"
      isFullWidth={isFullWidth}
      required={required}
      status={invalid ? { level: 'error', message: error?.message } : undefined}
      id={`action-textarea-${name}`}
      label={label}
      helpText={tip}
      description={<FieldDescription>{tip}</FieldDescription>}
      input={
        <TextArea
          {...field}
          {...restProps}
          isFullWidth={isFullWidth}
          placeholder={placeholder}
          value={field.value || ''}
          {...(error ? { palette: 'expressiveNegative' as const } : {})} // workaround for alchemy-ui issue https://jira.medallia.com/browse/DES-3074
        />
      }
    />
  );
};
